import { BaseUrl } from "@/config";
import { readonly } from "vue";
import { useRoute } from "vue-router";

export function useMetaTags() {
  const route = useRoute();

  const selfCanonical = computed(() => {
    return `${BaseUrl}${route.path}`;
  });

  const selfCanonicalWithQuery = computed(() => {
    return `${BaseUrl}${route.fullPath}`;
  });

  return {
    selfCanonical: readonly(selfCanonical),
    selfCanonicalWithQuery: readonly(selfCanonicalWithQuery),
  };
}
